const Footer = () => {
  return <div id="footer">Created by Nawed Zaman @FoodExpress2023</div>;
};
export default Footer;
